import { publicPath } from '../publicPath';

/** @deprecated Prefer `PLACY_LOGO_SRC`. */
export const OFFIZZ_LOGO_SRC = publicPath('/placy-logo.png');

/** Full-bleed Placy landing art (logo + tagline + cityscape) for the session splash. */
export const PLACY_LANDING_SRC = publicPath('/placy-landing.png');

/** Placy wordmark + tagline for sign-in and other brand slots. */
export const PLACY_LOGO_SRC = publicPath('/placy-logo.png');

/** App / PWA icon mark. */
export const PLACY_ICON_SRC = publicPath('/placy-icon.png');

/** @deprecated Prefer the full landing art on splash; kept for any remaining strip usage. */
export const PLACY_CITYSCAPE_SRC = publicPath('/placy-cityscape.png');

/** @deprecated Prefer `PLACY_LOGO_SRC` — kept for older imports. */
export const OFFIZZ_LANDING_LOGO_SRC = PLACY_LOGO_SRC;

type PlacyLogoWatermarkProps = {
  className?: string;
};

/** Placy wordmark, used as a faint banner watermark. */
export function OffizzLogoWatermark({ className }: PlacyLogoWatermarkProps) {
  return (
    <img
      src={PLACY_LOGO_SRC}
      alt=""
      className={className}
      aria-hidden
      draggable={false}
    />
  );
}

export const PlacyLogoWatermark = OffizzLogoWatermark;

type PlacyBrandMarkProps = {
  className?: string;
  /** Single-color mark for faint banner backgrounds. */
  watermark?: boolean;
};

/** Placy pin-style mark used on splash and profile header. */
export function OffizzBrandMark({ className, watermark = false }: PlacyBrandMarkProps) {
  const innerFill = watermark ? 'currentColor' : '#fff';
  const accentFill = watermark ? 'currentColor' : '#7B5AFF';

  return (
    <svg className={className} viewBox="0 0 120 120" aria-hidden>
      <circle cx="60" cy="52" r="34" fill="none" stroke="currentColor" strokeWidth="10" />
      <circle cx="60" cy="52" r="22" fill={innerFill} />
      <path fill="currentColor" d="M44 58 L60 78 L76 58 Z" />
      <path fill={accentFill} d="M60 86 L66 94 L54 94 Z" />
    </svg>
  );
}

export const PlacyBrandMark = OffizzBrandMark;
